import { aliases, cssNuxtIcon, svgNuxtIcon } from '../nuxt-icon-set/common'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vuetify:before-create', ({ vuetifyOptions }) => {
    vuetifyOptions.icons = { aliases, defaultSet: 'svgNuxtIcon', sets: { svgNuxtIcon, cssNuxtIcon } }
  })
})
